import { render } from "./transactions-page.vue?vue&type=template&id=dd483cb0&ts=true"
import script from "./transactions-page.vue?vue&type=script&lang=ts"
export * from "./transactions-page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__